<template>
  <div class="container">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
    </div>
    <div v-if="continued === false" style="width: 100%; margin-top: 10px">
      <div id="carousel-container">
        <carousel :perPage="1" :navigationEnabled="true" :navigationClickTargetSize="20" :paginationPadding="5" paginationColor="#dddddd" :paginationActiveColor="chatbotColors.sentMessage.bg">
          <slide v-for="(option, idx) in message.data.options" :key="idx">
            <div class="slide-container">
              <div class="titulo" :style="{ color: chatbotColors.sentMessage.bg }">{{ option.titulo }}</div>
              <div class="descricao" v-html="option.descricao"></div>
              <a href="#" @click.prevent="addOption(option)" class="botao" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }" v-if="adicionados.includes(option.id) === false">ADICIONAR</a>
              <a href="#" @click.prevent="removeOption(option)" class="botao remover" v-if="adicionados.includes(option.id)">ADICIONADO</a>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
    <div class="options-container" v-if="continued === false">
      <a href="#" class="botao" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }" @click.prevent="addAssists">{{ adicionados.length ? 'CONTINUAR' : 'CONTINUAR SEM ASSISTÊNCIAS' }}</a>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import escapeGoat from 'escape-goat'
// import Autolinker from 'autolinker'
import store from "./../store/"
// const fmt = require('msgdown')

export default {
  components: {
    Carousel,
    Slide
  },
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
      continued: false,
      adicionados: []
    }
  },
  computed: {
    messageText() {
      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;

      // const escaped = escapeGoat.escape(this.message.data.text)

      // return Autolinker.link(this.messageStyling ? fmt(escaped) : escaped, {
      //   className: 'chatLink',
      //   truncate: { length: 50, location: 'smart' }
      // })
    }
  },
  methods: {
    addOption (option) {
      this.adicionados.push(option.id);
    },
    removeOption (option) {
      const index = this.adicionados.findIndex(item => {
        return item == option.id;
      });

      this.adicionados.splice(index, 1);
    },
    addAssists () {
      this.continued = true;

      let text = 'Sem Assistência';
      let options = [];

      if (this.adicionados.length) {
        options = this.adicionados.map(item => {
          return this.message.data.options.find(option => {
            return option.id == item;
          });
        });

        const assists = options.map(option => option.titulo);
        text = assists.join(', ');
      }

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        bot: true,
        data: { key: null, text, metadata: options }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
a.chatLink {
  color: inherit !important;
}
#carousel-container {
  width: 230px;
  margin-top: 10px;
}
.slide-container {
  padding: 21px;
  margin-right: 10px;
  border-radius: 30px;
  background: #f1f1f1;

  .titulo {
    font-size: 1rem;
    font-weight: bold;
  }
  .descricao {
    margin-bottom: 10px;
    font-size: 0.8rem;
  }
  .botao {
    display: inline-block;
    padding: 8px 15px;
    border: 0;
    border-radius: 20px;
    font-size: 0.8rem;
    text-decoration: none;

    &:hover {
      opacity: .8;
    }
  }
  .botao.remover {
    background: #d40000;
    color: white;

    &:hover {
      opacity: .8;
    }
  }
}
.options-container {
  margin-top: 10px;

  .botao {
    display: inline-block;
    margin: 0 5px 5px 0;
    padding: 10px 15px;
    border-radius: 20px;
    /* font-weight: 300; */
    font-size: 14px;
    line-height: 1.4;
    position: relative;
    -webkit-font-smoothing: subpixel-antialiased;
    border: 0;
    text-decoration: none;
  }
  .botao:hover {
    opacity: .8;
  }
}
</style>
